import { setFulfillmentIssues, setPickingMethod } from '../../../../../services/Order/Order.service'
import { useMutation, useMutationState, useQueryClient } from '@tanstack/react-query'

const useSaveFulfillment = (orderId, orderItemId) => {
    const queryClient = useQueryClient()

    const saveFulfillmentIssuesMutation = useMutation({
        mutationKey: ['saveFulfillmentIssuesMutation', orderId, orderItemId],
        mutationFn: ({ fulfillmentIssues }) => setFulfillmentIssues(orderId, fulfillmentIssues),
        onSuccess: () => queryClient.invalidateQueries({queryKey: ['orders', orderId]})
    })

    const foundItemMutation = useMutation({
        mutationKey: ['foundItemMutation', orderId, orderItemId],
        mutationFn: async ({ orderItem, pickingMethod }) => {
            await setPickingMethod(orderId, pickingMethod, [orderItem.id])
            await setFulfillmentIssues(orderId, [{
                issueType: 'FOUND_ITEM',
                id: orderItem.id,
                itemAvailable: orderItem.quantity
            }])
        },
        onMutate: async ({ orderItem, pickingMethod }) => {
            queryClient.setQueryData(['orders', orderId], (prev) => {
                return {
                    ...prev,
                    orderItems: prev.orderItems.map(oi => {
                        if (oi.id === orderItem.id) {
                            return {
                                ...oi,
                                quantity: orderItem.quantity,
                                pickingMethod,
                            }
                        }
                        return oi
                    })
                }
            })
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ['orders', orderId] })
        }
    })

    const saveFulfillmentIssuesMutationStates = useMutationState({
        filters: { mutationKey: ['saveFulfillmentIssuesMutation', orderId, orderItemId] },
        select: (mutation) => mutation.state
    })

    const latestSaveFulfillmentIssuesMutationState = saveFulfillmentIssuesMutationStates[saveFulfillmentIssuesMutationStates.length - 1]
    const isPendingSaveFulfillmentIssuesMutation = latestSaveFulfillmentIssuesMutationState?.status === 'pending' || false

    const isPendingFoundItemMutationStates = useMutationState({
        filters: { mutationKey: ['foundItemMutation', orderId, orderItemId] },
        select: (mutation) => mutation.state,
    })

    const latestFoundItemMutationState = isPendingFoundItemMutationStates[isPendingFoundItemMutationStates.length - 1]
    const isPendingFoundItemMutation = latestFoundItemMutationState?.status === 'pending' || false

    return {
        saveFulfillmentIssuesMutation,
        foundItemMutation,
        isPendingFulfillment: isPendingSaveFulfillmentIssuesMutation || isPendingFoundItemMutation
    }
}



export { useSaveFulfillment }
